module.exports = __webpack_public_path__ + "static/img/hy.20a0c8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy.jpg
// module id = d5E0
// module chunks = 0